export const RESET_AUTH = "RESET_AUTH";
export const RESET_ALERT = "RESET_ALERT";
export const RESET_CARD = "RESET_CARD";
export const RESET_CART = "RESET_CART";
export const RESET_CONFIG = "RESET_CONFIG";
export const SET_CURRENT_CARD = "SET_CURRENT_CARD";
export const CLEAR_CURRENT_CARD = "CLEAR_CURRENT_CARD";
export const USER_CARDS_LOADING = "USER_CARDS_LOADING";
export const USER_CARDS_LOADED = "USER_CARDS_LOADED";
export const USER_CARDS_ERROR = "USER_CARDS_ERROR";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const CLEAR_ALERTS = "CLEAR_ALERTS";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CONFIG_LOADING = "USER_CARDS_LOADING";
export const CONFIG_LOADED = "USER_CARDS_LOADED";
export const CONFIG_LOAD_ERROR = "USER_CARDS_ERROR";
export const FORGOT_PWD_LINK_SUCCESS = "FORGOT_PWD_LINK_SUCCESS";
export const FORGOT_PWD_LINK_ERROR = "FORGOT_PWD_LINK_ERROR";
export const LINK_REQUEST = "LINK_REQUEST";
export const RESET_REQUEST = "RESET_REQUEST";
export const RESET_PWD_SUCCESS = "RESET_PWD_SUCCESS";
export const RESET_PWD_ERROR = "RESET_PWD_ERROR";
export const RESET_PWD_LINK_SUCCESS = "RESET_PWD_LINK_SUCCESS";
export const CARD_LOADED = "CARD_LOADED";
export const USER_CART_LOADING = "USER_CART_LOADING";
export const USER_CART_LOADED = "USER_CART_LOADED";
export const USER_CART_ERROR = "USER_CART_ERROR";
export const SET_CURRENT_CART_ITEM = "SET_CURRENT_CART_ITEM";
export const CLEAR_CURRENT_CART_ITEM = "CLEAR_CURRENT_CART_ITEM";
export const CART_PROCESSING = "CART_PROCESSING";
export const CART_PROCESSED = "CART_PROCESSED";
export const USER_ORDERS_LOADING = "USER_ORDERS_LOADING";
export const USER_ORDERS_LOADED = "USER_ORDERS_LOADED";
export const USER_ORDERS_ERROR = "USER_ORDERS_ERROR";
export const SET_CURRENT_ORDER = "SET_CURRENT_ORDER";
export const RECHARGE_CARDS_LOADING = "RECHARGE_CARDS_LOADING";
export const RECHARGE_CARDS_LOADED = "RECHARGE_CARDS_LOADED";
export const RECHARGE_CARDS_ERROR = "RECHARGE_CARDS_ERROR";
export const SUBSCRIBE_CARDS_LOADING = "SUBSCRIBE_CARDS_LOADING";
export const SUBSCRIBE_CARDS_LOADED = "SUBSCRIBE_CARDS_LOADED";
export const SUBSCRIBE_CARDS_ERROR = "SUBSCRIBE_CARDS_ERROR";
export const SUBSCRIBE_RESET_CARDS = "SUBSCRIBE_RESET_CARDS";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const ADD_SUBSCRIPTION = "ADD_SUBSCRIPTION";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const INIT_SUBSCRIBE = "INIT_SUBSCRIBE";
export const GROUPS_LOADING = "GROUPS_LOADING";
export const GROUPS_LOADED = "GROUPS_LOADED";
export const GROUPS_ERROR = "GROUPS_ERROR";
export const GROUPS_RESET = "GROUPS_RESET";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const SET_CURRENT_GROUP = "SET_CURRENT_GROUP";
export const CLEAR_CURRENT_GROUP = "CLEAR_CURRENT_GROUP";
export const EMPLOYEES_LOADING = "EMPLOYEES_LOADING";
export const EMPLOYEES_LOADED = "EMPLOYEES_LOADED";
export const EMPLOYEES_ERROR = "EMPLOYEES_ERROR";
export const EMPLOYEES_RESET = "EMPLOYEES_RESET";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const SET_CURRENT_EMPLOYEE = "SET_CURRENT_EMPLOYEE";
export const CLEAR_CURRENT_EMPLOYEE = "CLEAR_CURRENT_EMPLOYEE";
export const COMPCARDS_LOADING = "COMPCARDS_LOADING";
export const COMPCARDS_LOADED = "COMPCARDS_LOADED";
export const COMPCARDS_ERROR = "COMPCARDS_ERROR";
export const COMPCARDS_RESET = "COMPCARDS_RESET";
export const SET_CURRENT_COMPCARD = "SET_CURRENT_COMPCARD";
export const CLEAR_CURRENT_COMPCARD = "CLEAR_CURRENT_COMPCARD";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const EDIT_CART_ITEM = "EDIT_CART_ITEM";
export const INIT_EDIT_CART_ITEM = "INIT_EDIT_CART_ITEM";
export const SET_CURRENT_CONTRACT = "SET_CURRENT_CONTRACT";
export const CLEAR_CURRENT_CONTRACT = "CLEAR_CURRENT_CONTRACT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const GET_PAYMENT = "GET_PAYMENT";
export const SET_CURRENT_NAVIGATION = "SET_CURRENT_NAVIGATION";
export const NAVIGATIONS_RESET = "NAVIGATIONS_RESET";
export const SET_FIELD_REFS = "SET_FIELD_REFS";
export const CHECK_SUBSCRIPTION_ALLOWED = "CHECK_SUBSCRIPTION_ALLOWED";
export const AUTORUN_BANNER = "AUTORUN_BANNER";
export const FEEDBACK_LOADED = "FEEDBACK_LOADED";
export const FEEDBACK_LOADING = "FEEDBACK_LOADING";
export const FEEDBACK_LOAD_ERROR = "FEEDBACK_LOAD_ERROR";
export const ORDER_SUBMIT_SUCCESS = "ORDER_SUBMIT_SUCCESS";
export const ADD_RS_SUBSCRIPTION = "ADD_RS_SUBSCRIPTION";
